import React, { useState, useEffect } from 'react';
import Button from "@material-ui/core/Button";
import { NavLink } from "react-router-dom";
import { VisitAPI } from "../../API/api";

const Stat = () => {
    const [countVisit, setCountVisit] = useState(0);
    const [countRegUsers, setCountRegUsers] = useState(0);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         setCountVisit(await VisitAPI.getVisits());
    //         setCountRegUsers(await VisitAPI.getRegUsersCount());
    //     };
    //
    //     fetchData();
    //
    //     const intervalId = setInterval(fetchData, 18000000);
    //
    //     return () => clearInterval(intervalId);
    // }, []);

    return (
        <>
            <div style={{ margin: 10 }}>
                <NavLink to={'/'}>
                    <Button>
                        Назад
                    </Button>
                </NavLink>
            </div>
            <div>
                <div>Кол-во посещений: {countVisit}</div>
                <div>Кол-во регистрации: {countRegUsers}</div>
            </div>
        </>
    );
};

export default Stat;
